<template>
    <div>
        <!-- 遮罩 -->
        <div v-if="dialogVisible" class="PopUpPromptBj">
            <!-- 提示 -->
            <div class="PopUpPromptBox">
                <img src="@/assets/warn.png" style="margin: 20px 0 30px 0;">
                <div style="margin-bottom: 20px;">{{ title }}</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                title:'',
                dialogVisible:false
            }
        },
        methods:{
            open(title){
                this.title=title
                this.dialogVisible=true
                document.body.style.overflow = 'hidden';
                let that=this
                setTimeout(function() {
                    document.body.style.overflow = '';
                    that.dialogVisible=false
                }, 3000);
            }
        }

    }
</script>
<style lang="scss" scoped>
.PopUpPromptBj{
    background: rgba(0,0,0,0.6);
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
}
.PopUpPromptBox{
    width: 520px;
    position: fixed;
    top: 200px;
    left: 50%;
    transform: translateX(-50%);
    font-size:24px;
    padding: 20px;
    font-weight: 400;
    text-align: center;
    background: #fff;
}
</style>